<template>
    <section class="formatter">
        <div class="d-flex gap-5 groups">
            <div class="editor-row customize-editor-minimize unitType">
                <div class="editor-row-title">{{ $t('auto.dateStartOfStartOfTimeUnitType') }}</div>
                <CustomPicker v-model="clone.startOf.unit" :items="unitTypes" idKey="id" labelKey="label" />
            </div>
        </div>
        <div class="d-flex gap-5 groups">
            <TimezonePickerInput v-model="clone.startOf.fromTimezone" title="From Timezone" />
            <TimezonePickerInput v-model="clone.startOf.toTimezone" title="To Timezone" />
        </div>
        <div class="d-flex gap-5 groups">
            <FormatPickerInput v-model="clone.startOf.fromFormat" title="From Format" />
            <FormatPickerInput v-model="clone.startOf.toFormat" title="To Format" />
        </div>
        <div class="d-flex gap-5 groups">
            <LocalePickerInput v-model="clone.startOf.fromLocale" title="From Locale" />
            <LocalePickerInput v-model="clone.startOf.toLocale" title="To Locale" />
        </div>
    </section>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../../../../../utils/log2";
import TiptapEditor from "../../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import CustomPicker from "../../../../../../../../../components/pickers/CustomPicker.vue";
import FormatPickerInput from "../inputs/FormatPickerInput.vue";
import LocalePickerInput from "../inputs/LocalePickerInput.vue";
import TimezonePickerInput from "../inputs/TimezonePickerInput.vue";

const log = log2("DateStartOf.vue");
export default {
    name: "DateStartOf.vue",
    components: { CustomPicker, TiptapEditor, FormatPickerInput, LocalePickerInput, TimezonePickerInput },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "date.startOf", //date.add,date.sub,date.format,date.compare,startOf,endOf,date.diff
            inputs: [""],
            add: {
                value: "1",
                unit: "days",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                fromLocale: "en",
                toLocale: "en",
            },
            sub: {
                value: "1",
                unit: "days",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                fromLocale: "en",
                toLocale: "en",
            },
            format: {
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                toTimezone: "UTC",
                fromTimezone: "UTC",
                fromLocale: "en",
                toLocale: "en",
            },
            compare: {
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                checkPart: ["year", "month", "day", "hour", "minute", "second"],
            },
            startOf: {
                unit: "day",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                timezone: "UTC",
            },
            endOf: {
                unit: "day",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                timezone: "UTC",
            },
            diff: {
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                unit: "days",
            },
        };
        if (!clone.startOf) {
            clone.startOf = {
                unit: "day",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                timezone: "UTC",
            };
        }
        return {
            clone,
            unitTypes: [
                {
                    id: "hour",
                    label: "Hour",
                    description: "Start of an hour",
                },
                {
                    id: "day",
                    label: "Day",
                    description: "Start of a day",
                },
                {
                    id: "week",
                    label: "Wwek",
                    description: "Start of a week",
                },
                {
                    id: "month",
                    label: "Month",
                    description: "Start of a month",
                },
                {
                    id: "year",
                    label: "Year",
                    description: "Start of a year",
                },
            ],
        };
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
section.formatter {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;

    .groups {
        width: 100%;
        display: flex;
        gap: 5px;
        justify-content: space-between;

        .format-picker-section {
            width: 100%;
        }

        .locale-picker-section {
            width: 100%;
        }

        .timezone-picker-section {
            width: 100%;
        }

        .unitType {
            margin-bottom: 10px;
            margin-top: 15px;
            gap: 15px;
        }
    }
}
</style>
